import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { ActionSheetComponent } from './action-sheet.component';

@NgModule({
    imports: [CommonModule, MatListModule, MatIconModule, MatRippleModule],
    declarations: [ActionSheetComponent],
    exports: [ActionSheetComponent],
})
export class LibActionSheetModule {}
